<template lang="pug">
	v-dialog(v-model="_value")
		v-card
			v-toolbar(
				:color="colors.primary"
				dark)
				span.title {{title}}
			.container
				v-data-table(
						:items="items"
						:headers="headers"
						)
						template(slot="items" slot-scope="props")
								td {{props.item.product}}
								td {{props.item.upc}}
								td {{props.item.percentage }}
								td {{props.item.sale_price | mixFormatCurrency}}
								td {{props.item.offer_price | mixFormatCurrency}}
</template>

<script>
import MdlGroupOffer from '../../models/Sale/SlGroupedOffer'
import headers from './groupedDetailModalHeaders'
import CurrencyUtils from '../../mixins/reusable_mixins/CurrencyUtils'

function initialState() {
    return {
        loading: false,
        data: null,
        headers,
    }
}

export default {
    mixins: [CurrencyUtils],
    props: {
        value: {
            type: Boolean,
            default: () => false,
        },
        offerId: {
            type: [Number, null],
            default: () => null,
        },
    },
    data: () => initialState(),
    computed: {
        _value: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        title() {
            if (this.loading) return 'Cargando...'
            if (this.data && this.data.name) return this.data.name
            return ''
        },
        items() {
            if (this.data && this.data.sl_offers && this.data.sl_offers.length)
                return this.data.sl_offers.map(i => {
                    let o = {}
                    o.product = i.wh_product ? i.wh_product.name : ''
                    o.upc = i.wh_product
                        ? i.wh_product.upc_codes.join(', ')
                        : ''
                    o.percentage = i.wh_product
                        ? `${i.discount_percentage}%`
                        : ''
                    o.sale_price = i.sale_price || ''
                    o.offer_price = i.offer_price || ''
                    return o
                })
            return []
        },
    },
    methods: {
        async fetchData(id) {
            this.loading = true
            let mdl = new MdlGroupOffer()
            let data = await mdl.include('sl_offers.wh_product').find(id)
            this.data = data
            this.loading = false
        },
    },
    watch: {
        offerId: {
            immediate: true,
            async handler(val) {
                if (val) {
                    await this.fetchData(val)
                }
            },
        },
    },
}
</script>
